import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { MonitoreoBrocaService } from "../../../../generated/grpc/monitoreo_broca_pb";
import { grpcMonitoreoBrocaDatabase } from "../database/GrpcMonitoreoBrocaDatabase";
import { MonitoreoBrocaRequest } from "../request/MonitoreoBrocaRequest";
import { MonitoreoBrocaResponse } from "../response/MonitoreoBrocaResponse";
import { fx_createMonitoreoBrocaGrpcService, toMonitoreoBrocaResponse } from "./MonitoreoBrocaGrpcService";

/** Variante gRPC-Web de `MonitoreoBrocaSaveService` (ver ese archivo):
 *  guardado (crear/editar, `id` null = crear) de un monitoreo de broca. El
 *  server persiste tal cual los conteos/porcentajes/índices que ya calculó el
 *  cliente -no los recalcula-, así que el request manda el objeto completo
 *  (a diferencia del `MonitoreoBrocaItem` de lectura, que sí recorta los
 *  derivados que nadie lee, ver `MonitoreoBrocaGrpcService.ts`). */
export class MonitoreoBrocaSaveGrpcService
  implements ISaveService<MonitoreoBrocaRequest, MonitoreoBrocaResponse>
{
  async saveAsync(
    request: MonitoreoBrocaRequest,
  ): Promise<MonitoreoBrocaResponse> {
    const client = createClient(MonitoreoBrocaService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardar({
        id: request.id ?? undefined,
        loteId: request.loteId,
        fecha: request.fecha,
        arbolesEvaluados: request.arbolesEvaluados,
        arbolesBrocados: request.arbolesBrocados,
        frutosEvaluados: request.frutosEvaluados,
        arbolesLimpios: request.arbolesLimpios,
        frutosBrocados: request.frutosBrocados,
        posicion1: request.posicion1,
        posicion2: request.posicion2,
        ausentes: request.ausentes,
        muertas: request.muertas,
        totales: request.totales,
        porcentajePosicion1: request.porcentajePosicion1,
        porcentajePosicion2: request.porcentajePosicion2,
        porcentajeAusentes: request.porcentajeAusentes,
        porcentajeMuertas: request.porcentajeMuertas,
        promedioGranosXRama: request.promedioGranosXRama,
        infestacionGeneral: request.infestacionGeneral,
        infestacionReal: request.infestacionReal,
        mortalidad: request.mortalidad,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    fx_createMonitoreoBrocaGrpcService(saved.fincaId).clearCache();
    await grpcMonitoreoBrocaDatabase.putOneAsync(saved);
    return toMonitoreoBrocaResponse(saved);
  }
}

/** Instancia única del servicio gRPC de guardado de monitoreos de broca. */
export const monitoreoBrocaSaveGrpcService = new MonitoreoBrocaSaveGrpcService();
